import React from "react"

const Live = () => {
  var sessionDate = new Date("December 10, 2020 12:00:00")
  // var todayDate = new Date()
  var todayDate = new Date("December 09, 2020 12:00:00")

  var isEventToday = false
  if (
    todayDate.getTime() === sessionDate.getTime() ||
    todayDate.getTime() > sessionDate.getTime()
  ) {
    isEventToday = true
  }

  return (
    <div className="live" id="live" data-aos="fade-down" data-aos-delay="500">
      <div className="container">
        <div className="live__content">
          <img className="live__image" src="./live-heading.svg" />

          {isEventToday ? (
            <div className="live__session">
              <iframe
                src="https://player.vimeo.com/video/483271230"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
              ></iframe>
            </div>
          ) : (
            <img className="live__image" src="./live-stream.svg" />
          )}

          <p className="live__text">
            Scroll down the page to check out the different experiences and
            their zoom links
          </p>
        </div>
      </div>
    </div>
  )
}

export default Live
